import React, { Component, Fragment } from "react";
import {
  UncontrolledButtonDropdown,
  DropdownToggle,
} from "reactstrap";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";

import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import UserService from "../../services/UserService";
import StorageService from "../../services/Storage";
import { setUserDetail, isProfileUpdate } from "../../actions/UserAction";

import "./UserBox.css";
import Storage from "../../services/Storage";
import { Roles } from "../../constants/constant.role";

class UserBox extends Component {
  state = {
    isModalVisible: false,
    ownerName: null,
    sapId: null,
    profileCompletePercentage: 0,
    redirectToProfile: false,
    profileImage: null,
    zone: null
  };

  componentDidMount() {
    let userDetail = this.props.userDetail;
    if (!userDetail) {
      this.getUserInfo();
    } else {
      this.setValues(userDetail);
    }
  }

  getUserInfo = () => {
    UserService.getUserInfo()
      .then(data => {
        let userData = data.data.data;
        Storage.setUserDetail(userData);
        this.props.setUserDetail(userData);
        this.props.isProfileUpdate(false);
        this.setValues(userData);
      })
      .catch(e => {
        console.error("e", e);
      });
  };

  componentWillReceiveProps(props) {
    let isProfileUpdate = props.isProfileUpdateState;
    let userDetail = props.userDetail;
    if (isProfileUpdate) {
      this.getUserInfo();
    }
    if (userDetail) {
      this.setValues(userDetail);
    }
  }

  setValues = uDetail => {
    let { member_id, owner_name, image_url, area_name, zone } = uDetail;
    let { ownerName, sapId, profileImage } = this.state;
    ownerName = owner_name;
    sapId = member_id;

    let filledFields = 0;
    let fields = [
      "email_1",
      "telephone_no_1",
      "gst_number",
      "pan_number",
      "whats_app_number_user",
      "alternate_contact_person",
      "alternate_contact_number",
      "designation",
      "alternate_contact_email",
      "whats_app_number",
      "birth_date",
      "anniversary_date",
      "facebook_url",
      "instagram_url",
      "website",
    ];
    let totalFields = fields.length;

    for (let i = 0; i < fields.length; i++) {
      let field = fields[i];
      if (!(uDetail[field] === null || uDetail[field] === "")) {
        filledFields++;
      }
    }
    let percentage = (filledFields / totalFields) * 100;
    percentage = Math.floor(percentage);
    profileImage = image_url;
    let areaName = area_name;
    this.setState({
      ownerName,
      sapId,
      profileCompletePercentage: percentage,
      profileImage,
      areaName,
      zone
    });
  };

  redirectToProfile = () => {
    this.setState({ redirectToProfile: true });
  };

  // openProfileModal = () => {
  //   this.redirectToProfile();
  //   //this.setState({ isModalVisible: !this.state.isModalVisible });
  // };

  // redirectToProfile = () => {
  //   this.setState({ redirectToProfile: true });
  // };

  render() {
    let userRoleDetail = StorageService.getUserDetail();
    let userRole = userRoleDetail.type;
    let { location } = this.props;
    return (
      <Fragment>
        <UncontrolledButtonDropdown id="user-box">
          <DropdownToggle>
            {userRole === Roles.FLEET_ROLE && (
              <Fragment>
                {this.state.redirectToProfile && location && location.pathname !== "/profile" && (
                  <Redirect to="/profile"></Redirect>
                )}
                {this.state.profileImage && (
                  <img
                    className="header-menus cursor-pointer"
                    src={this.state.profileImage}
                    alt=""
                    onClick={this.openProfileModal}
                  ></img>
                )}
                {!this.state.profileImage && (
                  <img
                    className="header-menus cursor-pointer"
                    src="images/Web_Avatar.svg"
                    alt=""
                    onClick={this.openProfileModal}
                  ></img>
                )}
                <FontAwesomeIcon
                  className="ml-2 opacity-8 arrow-color cursor-pointer"
                  icon={faAngleDown}
                  onClick={this.redirectToProfile}
                />

                <div className="user-detail" onClick={this.redirectToProfile}>
                  <div className="user-name title-case">
                    {this.state.ownerName}
                  </div>
                  <div className="sap-id">{this.state.sapId}</div>
                </div>
              </Fragment>
            )}

            {(userRole === Roles.FLEET_MANAGER_ROLE ||
              userRole === Roles.HEAD_OFFICE_BAADSHAH_ROLE) && (
                <Fragment>
                  <div className="user-box-area-manager title-case">
                    {userRole === Roles.HEAD_OFFICE_BAADSHAH_ROLE
                      ? (userRoleDetail.owner_name || '')
                      : `Fleet Manager - ${userRoleDetail.area_name || ''}`}
                  </div>
                </Fragment>
              )}

            {userRole === Roles.ZONAL_FLEET_MANAGER_ROLE && (
              <Fragment>
                <div className="user-box-area-manager title-case">
                  Zonal Fleet Manager -{" "}
                  <span className="capital-case">{userRoleDetail.zone || ''}</span>
                </div>
              </Fragment>
            )}
          </DropdownToggle>
          {/* 
      {userRole !== Roles.FLEET_MANAGER_ROLE ? <Fragment>
        {this.state.redirectToProfile && <Redirect to="/profile"></Redirect>}
        {this.state.profileImage && <img className="header-menus cursor-pointer" src={this.state.profileImage} alt="" onClick={this.openProfileModal}></img>}
        {!this.state.profileImage && <img className="header-menus cursor-pointer" src="images/Web_Avatar.svg" alt="" onClick={this.openProfileModal}></img>}
        <FontAwesomeIcon className="ml-2 opacity-8 arrow-color cursor-pointer" icon={faAngleDown} onClick={this.openProfileModal} />
        <Row style={{ marginLeft: '5px' }} className="cursor-pointer" onClick={this.openProfileModal}>
          <Col>
            <div className="user-name title-case">{this.state.ownerName}</div>
            <div className="sap-id">{this.state.sapId}</div>
          </Col>
        </Row>
      </Fragment>
        :
        <Fragment>
          <div className="user-box-area-manager title-case">
            Fleet Manager - {this.state.areaName}
          </div>
        </Fragment>
      } */}

          {/* {this.state.redirectToProfile && <Redirect to="/profile"></Redirect>}
      {this.state.profileImage && <img className="header-menus" src={this.state.profileImage} alt=""></img>}
      {!this.state.profileImage && <img className="header-menus" src="images/Web_Avatar.svg" alt=""></img>}
      <FontAwesomeIcon className="ml-2 opacity-8 arrow-color cursor-pointer" icon={faAngleDown} onClick={this.openProfileModal} />
      <Row style={{ marginLeft: '5px' }}>
        <Col>
          <div className="user-name title-case">{this.state.ownerName}</div>
          <div className="sap-id">{this.state.sapId}</div>
        </Col>
      </Row> */}
          {/* {[Roles.FLEET_ROLE].includes(userRoleDetail.type) && (
            <DropdownMenu>
              <DropdownItem>
                <div>
                  <Card
                    
                    className="card-width"
                  >
                    <CardBody>
                      <Row>
                        <Col className="title">
                          PROFILE COMPLETION PROGRESS:
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col>
                          <Progress
                            className="mb-3 progress-bar-container"
                            value={this.state.profileCompletePercentage}
                          >
                            {this.state.profileCompletePercentage}%
                          </Progress>
                        </Col>
                      </Row>
                      
                      <Row>
                        <Col
                          className="text-align-right button-text cursor-pointer"
                          onClick={this.redirectToProfile}
                        >
                          {this.state.profileCompletePercentage === 100
                            ? "View profile"
                            : "Complete your Profile now"}
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </div>
              </DropdownItem>
            </DropdownMenu>
          )} */}
        </UncontrolledButtonDropdown>
      </Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  setUserDetail: user => dispatch(setUserDetail(user)),
  isProfileUpdate: bool => dispatch(isProfileUpdate(bool))
});

const mapStateToProps = state => ({
  userDetail: state.User.user,
  isProfileUpdateState: state.User.isProfileUpdate
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(UserBox));
